import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';


import { CertificationPage } from './certification.page';
import { AccordionComponent } from '../../components/accordion/accordion/accordion.component'
import { AccordionPanelComponent } from '../../components/accordion/accordion-panel/accordion-panel.component'
import { CertificationCategoryComponent } from './certification-category/certfication-category.component';
import { CertificationAnswerComponent } from './certification-answer/certification-answer.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule
  ],
  declarations: [
    CertificationPage,
    AccordionComponent,
    AccordionPanelComponent, 
    CertificationCategoryComponent,
    CertificationAnswerComponent
  ]
})
export class CertificationPageModule {}
